import Gist from "react-gist";
import * as React from 'react';
export default {
  Gist,
  React
};